const initialState = {
  visible: false,
	list: [],
  title: null,
  categoryChild: [],
  categoryParent: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'HELP_SET') {
		let newState = Object.assign({}, state);

    let answerVisible = (action.payload.list.length > 1) ? false: true;
    let list = action.payload.list.map((value, index) => {
      return({...value, answerVisible: answerVisible})
    })
    newState.list = list;
    newState.title = action.payload.title;
    newState.categoryChild = action.payload.categoryChild;
    newState.categoryParent = action.payload.categoryParent;
    newState.visible = true;

		return newState;
	}
  else if (action.type === 'HELP_INIT') {
		let newState = Object.assign({}, state);
    newState = initialState;
		return newState;
	}
  else if (action.type === 'HELP_ANSWER_TOGGLE') {
    let newState = Object.assign({}, state);
    let index = newState.list.findIndex((item) => item.id === action.payload.id);

    if (index >= 0) {
      if (newState.list[index]['answerVisible']) {
        newState.list[index]['answerVisible'] = false;
      }
      else {
        newState.list[index]['answerVisible'] = true;
      }
    }
    return newState;
  }
	else {
		return state;
	}
}
